function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3636 2.98187H8.72727V0.800049H1.09091C0.490909 0.800049 0 1.29096 0 1.89096V7.89096H1.09091C1.09091 8.79641 1.82182 9.52732 2.72727 9.52732C3.63273 9.52732 4.36364 8.79641 4.36364 7.89096H7.63636C7.63636 8.79641 8.36727 9.52732 9.27273 9.52732C10.1782 9.52732 10.9091 8.79641 10.9091 7.89096H12V5.16368L10.3636 2.98187ZM10.0909 3.80006L11.16 5.1637H8.72726V3.80006H10.0909ZM2.18181 7.89096C2.18181 8.19096 2.42726 8.43641 2.72726 8.43641C3.02726 8.43641 3.27272 8.19096 3.27272 7.89096C3.27272 7.59096 3.02726 7.34551 2.72726 7.34551C2.42726 7.34551 2.18181 7.59096 2.18181 7.89096ZM3.93819 6.80004C3.63819 6.46731 3.21274 6.25459 2.72729 6.25459C2.24183 6.25459 1.81638 6.46731 1.51638 6.80004H1.09092V1.89095H7.63638V6.80004H3.93819ZM8.72726 7.89096C8.72726 8.19096 8.97272 8.43641 9.27272 8.43641C9.57272 8.43641 9.81817 8.19096 9.81817 7.89096C9.81817 7.59096 9.57272 7.34551 9.27272 7.34551C8.97272 7.34551 8.72726 7.59096 8.72726 7.89096Z",
  fill: "black"
});

function SvgLogisticsTiny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogisticsTiny);
export default __webpack_public_path__ + "static/media/LogisticsTiny.08e0bf14.svg";
export { ForwardRef as ReactComponent };